import Offers from "../../features/dashboard/offers/Offers"

function OffersDB() {
    return <Offers />
}

export default OffersDB